import React, { useState, useEffect } from "react";
import "./Styles/HeroSec.css";

import { motion, useTransform, useViewportScroll } from "framer-motion";

function HeroSec() {
  const [velocilty, setVelocilty] = useState(0);
  const { scrollY } = useViewportScroll();
  const vWidth = window.innerWidth;
  // const [elementTop, setElementTop] = useState(0);
  // const ref = useRef(null);

  //-- animations
  const scrollIntro = useTransform(
    scrollY,
    [0, velocilty, velocilty + 1],
    [0, -velocilty, -velocilty],
    {
      clamp: false,
    }
  );

  // const keepHero = useTransform(
  //   scrollY,
  //   [0, velocilty, velocilty + 1],
  //   [0, velocilty, velocilty],
  //   {
  //     clamp: false,
  //   }
  // );

  useEffect(() => {
    if (vWidth > 600) {
      setVelocilty(336);
    } else {
      setVelocilty(153);
    }
  }, [vWidth]);

  // useLayoutEffect(() => {
  //   const element = ref.current;
  //   setElementTop(element.offsetTop);
  // }, [ref]);

  return (
    <motion.div className="herosec">
      <motion.div className="herosec__intro">
        <motion.h1
          initial={{
            y: 50,
            opacity: 0,
          }}
          animate={{
            y: 0,
            opacity: 1,
          }}
          transition={{ type: "tween", duration: 0.5 }}
          className="herosec__fonts"
        >
          Hi, I'm
        </motion.h1>
        <motion.div
          initial={{
            y: 50,
            opacity: 0,
          }}
          animate={{
            y: 0,
            opacity: 1,
          }}
          transition={{
            type: "tween",
            duration: 0.5,
            delay: 0.5,
          }}
          className="herosec__title"
        >
          <h1 className="A herosec__fonts">A</h1>
          <motion.h1
            className="herosec__fonts"
            style={{ color: "rgb(41, 40, 40)", y: scrollIntro }}
          >
            zhar
          </motion.h1>
          <motion.h1
            className="herosec__fonts herosec__stroke"
            style={{ color: "transparent", y: scrollIntro }}
          >
            &nbsp;designer
          </motion.h1>
          <motion.h1
            className="herosec__fonts herosec__stroke"
            style={{ color: "transparent", y: scrollIntro }}
          >
            &nbsp;coder
          </motion.h1>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export default HeroSec;
